import StudentLog from "./StudentLog/StudentLog";

const MyLog = () => {
  return (
    <>
      <StudentLog />
    </>
  );
};

export default MyLog;
